import {api} from './Api';
import {
  IWebhook
} from '../models';

export const createWebhook = (webhook: IWebhook) => {
  const payload = {
    active: webhook.active,
    report_id: webhook.report_id,
    token: webhook.token,
    recipients: webhook.recipients ? JSON.stringify(webhook.recipients) : undefined,
    details: webhook.details ? JSON.stringify(webhook.details) : undefined,
  }
  return api.post(`/webhook/`, payload).then((res: any) => res.data);
}

export const updateWebhook = (uid: string, webhook: IWebhook) => {
  const payload = {
    ...webhook,
  }
  if (payload.recipients) {
    payload.recipients = JSON.stringify(payload.recipients);
  }
  if (payload.details) {
    payload.details = JSON.stringify(payload.details);
  }

  return api.put(`/webhook/${uid}`, payload).then((res: any) => res.data);
}

export const deleteWebhook = (uid: string) => {
  return api.delete(`/webhook/${uid}`);
}
